module.exports = __webpack_public_path__ + "static/media/ps.f07e2534.svg";